<template>
  <div>
    <!-- page meta -->
    <Head>
      <title>Platforma Worldwide Status</title>
      <link
        rel="icon"
        :href="$filters.public_path('favicon.png')"
        type="favicon"
      />
      <meta
        name="description"
        content="Build, host, and sell a subscriber hub for all your digital products. Monetize and protect your content."
      />
    </Head>
  </div>
  <!-- content start -->
  <body class="content-center overflow-x-hidden bg-[#fafbfc] font-['poppins']">
    <!-- ===================== NEW HEADER ===================== -->
    <div
      class="min-[950px]:max-w-[950px] container relative mx-auto bg-transparent px-[25px]"
    >
      <div class="flex w-full mt-[50px] justify-between">
        <!-- logo -->
        <Link href="/">
          <img
            :src="$filters.media_path('/images/NEW_PLATFORMA_LOGO_1.svg')"
            alt="Platforma logo"
          />
        </Link>
        <!-- subs -->
        <!-- <button -->
        <!--   class="bg-white hover:bg-[#dbdbdb] rounded-[5px] w-[100px] h-[32px] text-sm text[#292d34] border-[1px]" -->
        <!-- > -->
        <!--   SUBSCRIBE -->
        <!-- </button> -->
      </div>

      <div
        class="h-[52px] w-full bg-[#27AE60] rounded-[5px] mt-[75px] py-[15px] pl-5"
      >
        <h1 class="text-white text-lg font-medium my-auto">
          100% Online - All Systems Operational
        </h1>
      </div>

      <div
        class="w-full h-[100px] border-[1px] border-[#C9C9C9] rounded-[5px] mt-[50px]"
      >
        <h2 class="text-[#292d34] font-normal text-lg mt-[10px] ml-[10px]">
          Platforma Servers
        </h2>

        <div class="flex justify-between">
          <div class="flex ml-[20px] mt-[10px]">
            <div class="rounded-[5px] bg-[#27AE60] px-[5px] py-[5px]">
              <h4 class="text-white font-medium text-xs">North America East</h4>
            </div>

            <div class="rounded-[5px] bg-[#27AE60] px-[5px] py-[5px] ml-[15px]">
              <h4 class="text-white font-medium text-xs">South Asia</h4>
            </div>
          </div>

          <div>
            <h2 class="text-[#25d66f] font-normal text-lg mt-0 mr-[10px]">
              Operational
            </h2>
          </div>
        </div>
      </div>

      <h4 class="text-[#C9C9C9] font-normal text-[20px] mt-[70px]">
        External Services
      </h4>
      <div
        class="w-full h-[70px] border-[1px] border-[#C9C9C9] rounded-[5px] mt-[10px] py-[20px] flex"
      >
        <i
          class="fa fa-check font-bold text-[#27AE60] text-lg ml-[20px] inline"
        ></i>
        <h4 class="font-semibold ml-[5px] text-[#292d34]">
          Services Internal and Running
        </h4>
      </div>

      <h4 class="text-[#C9C9C9] font-normal text-[20px] mt-[70px]">History</h4>

      <h4
        class="text-[#292d34] font-normal text-[20px] mt-[70px] text-center mb-[260px]"
      >
        No incidents in last 7 days
      </h4>

      <footer class="flex h-[100px] align-bottom sm:justify-between xl:w-full">
        <div
          class="w-full pt-[25px] md:ml-[25px] xl:mx-auto xl:w-[1200px] justify-between flex"
        >
          <ul class="flex text-sm">
            <li>
              <a href="/status" class="font-semibold"> Status</a>
            </li>
            <li class="ml-[20px]">History</li>
            <li>
              <a href="mailto:info@platformarea.com" class="ml-[20px]"
                >Report Issue</a
              >
            </li>
          </ul>

          <div>
            <ul class="text-sm">
              <Link href="/">
                <li>Powered by Platforma</li>
              </Link>
            </ul>
          </div>
        </div>
      </footer>
    </div>
  </body>
</template>

<script></script>

<style scoped></style>
